import React from 'react';
import { Star } from 'lucide-react';

const MARQUEE_ITEMS = [
  'Premium Quality', 'Farm Fresh', 'Export Grade', 'FSSAI Certified',
  'Global Shipping', 'Competitive Pricing', 'Bulk Orders', 'Custom Packaging'
];
const MARQUEE_COPIES = [1, 2, 3, 4];

export default function Marquee() {
  return (
    <div className="bg-saffron overflow-hidden py-3" data-testid="marquee-band">
      <div className="marquee-track flex gap-8 whitespace-nowrap">
        {MARQUEE_COPIES.flatMap(copy => MARQUEE_ITEMS.map(item => (
          <span key={`${copy}-${item}`} className="text-white/90 font-sans text-xs uppercase tracking-[0.2em] font-semibold flex items-center gap-2">
            <Star size={10} className="text-white/50" />
            {item}
          </span>
        )))}
      </div>
    </div>
  );
}
